import React from "react";
import Plan from "../../plan";
import { Modal } from "antd";

const PlanModal = (props) => {
  const { visible, onHide } = props;

  const closeModal = () => {
    onHide();
  };
  return (
    <Modal
      width={"vw"}
      style={{
        height: "100vh",
        maxWidth: "100vw",
        position: "absolute",
        top: 0,
        left: 0,
      }}
      styles={{
        body: {
          height: "100vh",
          width: "100vw",
          padding: "24px",
        },
      }}
      className={"no-padding no-border-radius"}
      closable={false}
      open={visible}
      footer={null}
      destroyOnClose={true}
    >
      <Plan closeModal={closeModal} />
    </Modal>
  );
};

export default PlanModal;
